(function ($) {
  Drupal.behaviors.coursefinder = {
    attach: function (context, settings) {
      // query string values to allow link sharing to open at the required course
      var foundationID;
      var ai;
      var urlParams = new URLSearchParams(window.location.search);


      // select subject options object
      const optsSelect = document.getElementsByName('field_oncampus_subject_code_target_id')[0];
      let opts = null;
      if (optsSelect) {
        opts = optsSelect.querySelectorAll('option');
      }
      // select subject options object
      const uniOptsSelect = document.getElementsByName('field_oncampus_university_target_id')[0];
      let uniOpts = null;
      if (uniOptsSelect) {
        uniOpts = uniOptsSelect.querySelectorAll('option');
      }
      // // get the values of the current subject code select options
      // let currentArrayValues = Array.from(opts)
      //   .map(el => Number(el.value));
      //
      // // the 'all' option returns a NaN value, so remove it
      // currentArrayValues = currentArrayValues.filter(value => !Number.isNaN(value))

      //console.log(currentArrayValues);

      // reset hidden status to show all
      function showAllOPts(select) {
        //console.log(select);
        let thisSelect = select.querySelectorAll('option');
        $(thisSelect).prop('disabled', false).removeClass('opt-hide');
      }

      // make array unique only
      function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
      }

      // diff between two arrays
      Array.prototype.diff = function (a) {
        return this.filter(function (i) {
          return a.indexOf(i) < 0;
        });
      };

      // hide the options for the unavailable subject for this university
      function filterSubjects(availableSelectItems) {
        // console.log('filterSubjects');
        if (opts !== null) {
          opts.forEach(function (el) {
            //console.log('filter:' + el.value + '=' + (availableSelectItems.includes(Number(el.value))));
            if (!(availableSelectItems.includes(Number(el.value)))) {
              el.disabled = true;
              el.classList.add("opt-hide");
            }
          });
        }
      }

      // hide the options for the unavailable subject for this university
      function filterUniversities(availableSelectItems) {
        // console.log('filterSubjects');
        if (uniOpts !== null) {
          uniOpts.forEach(function (el) {
            //console.log('filter:' + el.value + '=' + (availableSelectItems.includes(Number(el.value))));
            if (!(availableSelectItems.includes(Number(el.value)))) {
              el.disabled = true;
              el.classList.add("opt-hide");
            }
          });
        }
      }

      function getSubjectListMedical(uniid) {
        return getSubjectList(uniid, '/medical-subject-areas-by-university-api/');
      }

      function getSubjectList(uniid, url) {
        url = url || '/subject-areas-by-university-api/'; // default URL if not provided
        var thisUrl = url + uniid;
        var thisSection = $('select[name="field_oncampus_university_target_id"]');
        $.ajax({
          type: "GET",
          dataType: 'json',
          url: thisUrl,
          dataType: "json",
          context: thisSection,
          success: function (result) {
            //console.log(result);
            var availableSelectItems = [];
            if (result.length > 0) {
              $.each(result, function (i, item) {
                availableSelectItems.push(Number(result[i].field_oncampus_subject_code));
              });

              // ... and strip out any duplicate items
              availableSelectItems = availableSelectItems.filter(onlyUnique);
              availableSelectItems = availableSelectItems.filter(item => item);
              // console.log(availableSelectItems);
              showAllOPts(optsSelect);
              filterSubjects(availableSelectItems);
            }
          },
          error: function (result) {
            console.log(result);
          }
        });
      }

      function getUniversityList(ctid) {
        var thisUrl = '/universities-by-country/' + ctid;
        var thisSection = $('select[name="field_oncampus_country_target_id"]');
        $.ajax({
          type: "GET",
          dataType: 'json',
          url: thisUrl,
          dataType: "json",
          context: thisSection,
          success: function (result) {
            //console.log(result);
            var availableSelectItems = [];
            if (result.length > 0) {
              $.each(result, function (i, item) {
                availableSelectItems.push(Number(result[i].tid));
              });

              // ... and strip out any duplicate items
              availableSelectItems = availableSelectItems.filter(onlyUnique);
              availableSelectItems = availableSelectItems.filter(item => item);
              // console.log(availableSelectItems);
              showAllOPts(uniOptsSelect);
              filterUniversities(availableSelectItems);
            }
          },
          error: function (result) {
            console.log(result);
          }
        });
      }

      // filter uni by country
      $('.views-exposed-form').on('change', 'select[name="field_oncampus_country_target_id"]', function () {
        var ctid = $(this).val();
        if (ctid.toLowerCase() === 'all') {
          showAllOPts(uniOptsSelect);
        } else {
          getUniversityList(ctid);
        }
      });


      // For the medical form specifically
      $('#views-exposed-form-progressions-only-medical').on('change', 'select[name="field_oncampus_university_target_id"]', function () {
        var uniid = $(this).val();
        if (uniid.toLowerCase() === 'all') {
          showAllOPts(optsSelect);
        } else {
          getSubjectListMedical(uniid);
        }
      });

      // For other forms (non-medical), keep the original
      $('.views-exposed-form').not('#views-exposed-form-progressions-only-medical').on('change', 'select[name="field_oncampus_university_target_id"]', function () {
        var uniid = $(this).val();
        if (uniid.toLowerCase() === 'all') {
          showAllOPts(optsSelect);
        } else {
          getSubjectList(uniid);
        }
      });


      if (urlParams.has('field_oncampus_country_target_id')) {
        var ctid = urlParams.get('field_oncampus_country_target_id');
        getUniversityList(ctid);
      }

      if (urlParams.has('field_oncampus_university_target_id')) {
        var uniid = urlParams.get('field_oncampus_university_target_id');
        getSubjectList(uniid);
      }


      // end subject filtering

      // dynamic dropdowns
      var countryList = '';
      var selectedCountry = '';
      $.ajax({
        type: "GET",
        dataType: 'json',
        url: '/countries-api-endpoint',
        dataType: "json",
        success: function (result) {
          //console.log(result);
          var output = '';
          output += '<option value="00">Please select</option>';
          $.each(result, function (i, item) {
            output += '<option value="' + result[i].id + '">' + result[i].country + '</option>';
          });
          countryList = '<div class="academic-requirements"><h4 class="text-20">Academic requirements</h4><p class="pt-2">Select your country of education</p><select class="countrylist" data-id="countrylistID-XXXX">' + output + '</select></div>';

        },
        error: function (result) {
          console.log(result);
        }
      });

      $('.views-element-container').on('click', '.foundation-id', function () {
        // only call is there is nothing here
        $('.foundation-id').attr('class', 'foundation-id');
        $(this).addClass('running');
        foundationID = $(this).data('foundation');
        var dataVal = $(this).data('foundation').split('|');
        var nid = dataVal[0];
        var oid = dataVal[1];
        var thisSection = $(this);
        var thisUrl = 'oncampus-products-api/' + nid + '/' + oid;
        //console.log(thisUrl);
        $.ajax({
          type: "GET",
          dataType: 'json',
          url: thisUrl,
          dataType: "json",
          context: thisSection,
          success: function (result) {
            //console.log(result);
            var output = '';
            var intakeSelect = "";
            var blockVisible = "show";
            var showIntakeSelect = false;
            //var showtitle = false;
            // if (result.length > 1) {
            //   showtitle = true;
            // }

            $.each(result, function (i, item) {
              var thisCountryList = countryList.replace('countrylistID-XXXX', result[i].field_oncampus_id_1);
              var blockId = 'intake-' + result[i].field_oncampus_id_1;
              var numberOfTerms = result[i].field_oncampus_terms
              if (numberOfTerms == '0') {
                numberOfTerms = 'To be announced';
              } else {
                numberOfTerms += ' Semesters';
              }

              if (i > 0) {
                showIntakeSelect = true;
              }
              intakeSelect += '<option value="' + blockId + '">' + result[i].field_oncampus_intake + '</option>';
              output += '<div class="prog-result-update ' + blockVisible + '" id="' + blockId + '">';
              // if (showtitle) {
              //   output += '<h3 class="medium-30">Intake Date: ' + result[i].field_oncampus_intake + '</h3>';
              // }
              //output += '<h4>JSON Result NID:'+nid+' OID:'+oid+'</h4>';
              output += '<h3 class="mb-1">Your chosen pathway</h3>';
              //output += '<h3 class="mb-1">Your ONCAMPUS centre: ' + result[i].field_oncampus_centre + '<br>';
              //output +=  result[i].field_oncampus_university + '</h3>';
              output += '<p class="mb-0">' + result[i].title + '</p>';
              output += '<p class="mb-5">Intake: ' + result[i].field_oncampus_intake + '</p>';
              output += '<div class="progression"><div class="step step-1">';
              let centreUrl = result[i].field_oncampus_centre_url;
              if (centreUrl?.trim()) {
                output += '<a href="'+ centreUrl +'" class="step-link">';
              }
              output += result[i].field_oncampus_centre;
              if (centreUrl?.trim()) {
                output += '</a>';
              }
              output += '</div>';
              output += '<div class="step step-arrow step-2">Progressing to</div><div class="step step-3">' + result[i].field_oncampus_university + '</div></div>';
              output += '<section class="cards cards--col-2 kpis type-2">';
              output += '<section class="cards cards--col-2 kpis type-2">';
              output += '  <div class="container">';
              output += '    <div class="row cards__wrapper">';
              output += '      <div class="paragraph paragraph--type--kpi paragraph--view-mode--default cards__card">';
              output += '        <div class="bg">';
              output += '          <div class="content-wrapper"><p class="text-30">English language requirements</p><p class="text-24 mb-0">' + result[i].field_english_reqs + '</p></div>';
              output += '        </div>';
              output += '      </div>';
              output += '      <div class="paragraph paragraph--type--kpi paragraph--view-mode--default cards__card">';
              output += '        <div class="bg border-only">';
              output += '          <div class="content-wrapper"><p class="text-30 class-hrs">Class hours per week</p><p class="text-24 mb-0">' + result[i].field_oncampus_hours_per_week + '</p></div>';
              output += '        </div>';
              output += '      </div>';
              // output += '<div class="paragraph paragraph--type--kpi paragraph--view-mode--default cards__card">';
              // output += '<div class="bg">';
              // output += '<div class="content-wrapper"><a href="/external-apply-form" class="btn btn-outline-tertiary">Apply now</a></div>';
              // output += '</div>';
              //output += '</div>';
              output += '    </div>'; //row cards__wrapper
              output += '  </div>'; //container
              output += '</section>'; //cards cards--col-2 kpis type-2
              output += '<div><h4 class="medium-30">Dates and fees</h4>';
              output += '<div class="table-responsive"><table class="table table-hover table-striped">';
              output += '<thead><th scope="col">Start and end date</th><th scope="col">Number of Semesters</th><th scope="col">Tuition fee</th></thead>';
              output += '<tbody><tr><td>' + result[i].field_start_date + ' - ' + result[i].field_end_date + '</td><td>' + numberOfTerms + '</td><td>' + result[i].field_oncampus_currency + result[i].field_oncampus_total_value + '</td></tr></tbody>';
              output += '</table></div>';
              output += '<p class="mb-5">All programmes are subject to a £350 registration fee. An Under 18 Supplement applies to all students under the age of 18 at the start of their programme.</p>';
              output += '</div>';
              output += '<h3 class="text-30 mt-5">Entry requirements</h3>';
              // output += '<br>field_oncampus_id: ' + result[i].field_oncampus_id;
              // output += '<br>field_oncampus_id_1: ' + result[i].field_oncampus_id_1;
              //output += '<br>field_oncampus_pathway: ' + result[i].field_oncampus_pathway;
              //output += '<br>field_oncampus_subject_area: ' + result[i].field_oncampus_subject_area;
              // output += '<br>field_oncampus_university: ' + result[i].field_oncampus_university;
              //output += '<br>nid: ' + result[i].nid;
              //output += '<br>nid_1: ' + result[i].nid_1;
              //output += '<br>title: ' + result[i].title;
              //output += '<br>title_1: ' + result[i].title_1 + '</p>';
              output += thisCountryList;
              output += '<div class="course-requirements"></div>';
              output += '<p class="small mt-2 mb-5">If your country is not listed, please contact <a href="mainto:admissions@oncampus.global">admissions@oncampus.global</a></p>';
              output += '<div class="age-req mb-5"><h4 class="text-20 mb-2">Age Requirements</h4>';
              output += '<p>' + result[i].field_oncampus_age_restriction + '</p>';
              output += '</div>';
              // output += '<div class="row application">';
              // output += '<div class="col-12"><div class="apply"><div class="row"><div class="col-12 col-lg-8"><h2 class="medium-30">Ready to apply for this course?</h2><p class="text-26">Start the application process now</p></div><div class="col-12 col-lg-4"><p><a href="#" class="btn btn-outline-tertiary">Apply now</a></p></div></div></div></div>';
              // output += '</div>';
              output += '<div class="mb-5"><p><em>The information on this website is provided for general informational purposes only. While we strive to ensure that all course details, descriptions, and related information are accurate and up-to-date, we strongly recommend verifying all details at the time of application.</em></p></div>';
              output += '<div class="row application">';
              output += '<div class="col-12 col-lg-6 d-flex"><div class="more h-100"><p class="text-30">Share this programme</p><p class="text-20">Click the button to copy the programme and share with others</p><span class="btn btn-outline-tertiary share-link"><span class="default">Share</span><span class="copied">Copied</span></div></div>';
              output += '<div class="col-12 col-lg-6 d-flex"><div class="apply h-100"><p class="text-30">Ready to apply?</p><p class="text-20">Start the application process now</p><a href="/external-apply-form" class="btn btn-outline-tertiary">Apply now</a></div></div>';
              output += '</div>';
              output += '</div>';
              blockVisible = 'hide';
            });
            if (showIntakeSelect === true) {
              intakeSelect = '<label class="medium-30 mb-1" for="intakelist' + nid + oid + '">Choose your intake date</label><select class="intakeSelect mb-5" id="intakelist' + nid + oid + '">' + intakeSelect + '</select>';
              output = intakeSelect + output;
            }
            //console.log($(this).parentsUntil('.accordion__item__content').parent().find('.prog-result-update'));
            var progResultUpdate = $(this).parentsUntil('.accordion__item__content').parent().find('.prog-result-update');
            var headerOffset = $('header.header').outerHeight() + 30;
            //console.log(headerOffset);
            progResultUpdate.html(output);
            $('html, body').animate({
              scrollTop: progResultUpdate.offset().top - headerOffset
            }, 'fast');
            $(this).removeClass('running');
            $(this).addClass('success');
          },
          error: function (result) {
            console.log(result);
            $(this).removeClass('running');
            $(this).addClass('error');
          }
        });

      });

      var $aiIndex = $('.accordion__group .accordion__item').click(function () {
        ai = $aiIndex.index(this);
        //console.log(ai);
      });

      $('.prog-result-update').on('click', '.share-link', function (e) {
        var url = window.location.href;
        if (urlParams.has('ai') && urlParams.has('foundation-id')) {
          url = url.replace('ai=' + urlParams.get('ai'), 'ai=' + ai);
          url = url.replace('foundation-id=' + urlParams.get('foundation-id'), 'foundation-id=' + foundationID);
        } else {
          url += '&ai=' + ai;
          url += '&foundation-id=' + foundationID;

        }
        //console.log(url);
        navigator.clipboard.writeText(url);
        $(this).addClass('active');
        setTimeout(function () {
          $('.share-link.active').removeClass('active');
        }, 3000);
      });

      $('.views-element-container').on('change', '.intakeSelect', function () {
        //console.log($(this).val());
        $('.prog-result-update.show').removeClass('show').addClass('hide');
        $('.prog-result-update#' + $(this).val()).removeClass('hide').addClass('show');
      });


      // go get the country specific details
      $('.views-element-container').on('change', '.countrylist', function () {

        var courseid = $(this).data('id');
        var countryid = $(this).val();
        var thisSection = $(this);
        var thisUrl = 'product-entry-requirements-endpoint/' + courseid + '/' + countryid;

        //console.log(thisUrl);

        $.ajax({
          type: "GET",
          dataType: 'json',
          url: thisUrl,
          dataType: "json",
          context: thisSection,
          success: function (result) {
            //console.log(result);
            var output = '';
            if (result.length > 0) {
              $.each(result, function (i, item) {
                //output += '<h4>Course JSON Result</h4>';
                output += '<p>' + result[i].description__value + '</p>';
              });
            } else {
              //output += '<h4>Course JSON Result</h4>';
              output += '<p>No details</p>';
            }
            //console.log(output);
            $(this).parent().next('.course-requirements').html(output);
          },
          error: function (result) {
            console.log(result);
          }
        });
      });


      if (urlParams.has('ai') && urlParams.has('foundation-id')) {
        var aiTarget = urlParams.get('ai');
        var fid = urlParams.get('foundation-id');
        $('.accordion__group .accordion__item:eq(' + aiTarget + ') button').click();
        $('.accordion__group .accordion__item:eq(' + aiTarget + ')').find('[data-foundation=\'' + fid + '\']').click();
        //console.log(urlParams.get('foundation-id'));
      }
      let lastValue = '';
      $('.no-results').on('change', '#oncampus-centre-links-selector', function (e) {
        if (e.currentTarget.value !== '0' && e.currentTarget.value !== lastValue) {
          let newLocation = '//' + location.hostname + e.currentTarget.value;
          //console.log(newLocation);
          window.location.href = newLocation;
          // $('#oncampus-centre-links-selector').after('<p class="loading">Please wait, loading...</p>');
          lastValue = e.currentTarget.value;
        }
      });
    }

  };
})(jQuery);
